// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__Po4rs","text":"style_text__VDIOi"};